import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, GuardsCheckEnd } from '@angular/router';
// Import our authentication service
import { AuthService, IUser } from './auth.service';
import { AppSettingsUrl } from '../appSettings';
import { Observable, map } from 'rxjs';
import { UserRoles } from './external/api';
import { LocalStorageService } from './localStorage.service';

@Injectable()
export class AuthGuard implements CanActivate {
    loginUrl = `${AppSettingsUrl.AuthUrl.rootUrl}/${AppSettingsUrl.AuthUrl.loginUrl}`;

    constructor(private auth: AuthService, private router: Router, private storage: LocalStorageService) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.routeValidation(this.auth.getUserData(), state);
    }

    routeValidation = (user: IUser, state: RouterStateSnapshot): boolean => {
        let url = state.url.toLowerCase();
        if (url.startsWith(`/auth?sid=`)) {
            const sid = state.root.queryParams['sid'];
            if (sid)
                try {
                    this.auth.restore(sid);
                } catch(e) {
                    console.log(e);
                }
        }
        if (!user) {
            if (url.startsWith(`/auth/`))
                return true;

            this.router.navigate([`auth/signin`]);
            return false;
        }
        if (url.indexOf(`/auth/`) != -1 && url.indexOf(`/auth/extramonth`) == -1) {
            this.router.navigate([`user/dashboard`]);
            return false;
        }
        const canManageData = this.auth.canManageData;
        const canViewUsers = this.auth.isParnter;
        if (url.indexOf(`/admin/users`) != -1 && !(canManageData || canViewUsers)) {
            this.router.navigate([`user/dashboard`]);
            return false;
        }
        if (url.indexOf(`/admin/promos`) != -1 && !(canManageData || canViewUsers)) {
            this.router.navigate([`user/dashboard`]);
            return false;
        }
        if (url.indexOf(`/admin/payments`) != -1 && !(canManageData || canViewUsers)) {
            this.router.navigate([`user/dashboard`]);
            return false;
        }
        if (url.indexOf(`/admin/tickers`) != -1 && !canManageData) {
            this.router.navigate([`user/dashboard`]);
            return false;
        }
        //if (url.indexOf(`/admin/schedules`) != -1 && !canManageData) {
        //	this.router.navigate([`user/dashboard`]);
        //	return false;
        //}
        return true;

    }
}
